import { render, staticRenderFns } from "./ModelStepItems.vue?vue&type=template&id=108db8dd&scoped=true&"
import script from "./ModelStepItems.vue?vue&type=script&lang=js&"
export * from "./ModelStepItems.vue?vue&type=script&lang=js&"
import style0 from "./ModelStepItems.vue?vue&type=style&index=0&id=108db8dd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108db8dd",
  null
  
)

export default component.exports